import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function changepassword(payload) {
    const result = await axios.post(apiUrl + "/admin/changepass",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}


export const ChangePasswordService = {
    changepassword,                
}